import { getAcceptLanguageHeader } from '../i18n';

const ADMIN_ENDPOINT = '/api/popup-messages/admin';

async function request(token, url, options = {}) {
  if (!token) {
    throw new Error('Не найден токен авторизации');
  }

  const response = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Accept-Language': getAcceptLanguageHeader(),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const data = JSON.parse(text);
      message = data?.message || data?.error || text;
    } catch {}
    throw new Error(message || `Ошибка запроса (${response.status})`);
  }

  if (response.status === 204) return null;
  return response.json();
}

export async function fetchPopupMessages(token) {
  const data = await request(token, ADMIN_ENDPOINT);
  const payload = data?.data ?? data?.messages ?? data;
  return Array.isArray(payload) ? payload : [];
}

export async function createPopupMessage(token, payload) {
  const data = await request(token, ADMIN_ENDPOINT, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return data?.data ?? data?.message ?? data;
}

export async function updatePopupMessage(token, id, payload) {
  const data = await request(token, `${ADMIN_ENDPOINT}/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
  return data?.data ?? data?.message ?? data;
}

export async function deletePopupMessage(token, id) {
  return request(token, `${ADMIN_ENDPOINT}/${id}`, { method: 'DELETE' });
}

export async function setPopupMessageEnabled(token, id, enabled) {
  const data = await request(token, `/api/popup-messages/${id}/enabled`, {
    method: 'PATCH',
    body: JSON.stringify({ enabled }),
  });
  return data?.data ?? data?.message ?? data;
}
